<div class="col-md-12 col-lg-12">
  <div class="col-sm-12"><h4><b>{{ "pages.createReceiptPage.additionalCharges" | translate }}</b></h4></div>
</div>
<table class="table mrgin-lft">
  <thead>
    <tr>
      <th></th>
      <th>{{ 'common.type' | translate }}</th>
      <th>{{ 'common.value' | translate }}</th>
      <th>{{ 'common.description' | translate }}</th>
      <th></th>
      <th>{{ 'common.amount' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of additionalCharges;index as i">
      <td style="padding-top: 13px;color: #dc291e;">
        <i *ngIf="!editable" class="armx-icon  armx-edit" (click)="editAdditionalCharges()"></i>
        <i *ngIf="editable" (click)="removeAdditionalCharge(i)" class="armx-icon armx-trash"></i>
      </td>
      <td>
        <span *ngIf="!editable">{{getSelectedChargeTypeText(item.chargeType)}}</span>
        <select *ngIf="editable" class="form-control" name="chargeType-{{i}}" [(ngModel)]="item.chargeType">
          <option *ngFor="let type of chargeTypes" value="{{type.Id}}">{{type.Description}}</option>
        </select>
      </td>
      <td><span *ngIf="!editable">{{item.chargeValue}}</span><input *ngIf="editable" type="number" min="0" class="form-control" name="chargeValue-{{i}}" [(ngModel)]="item.chargeValue" /></td>
      <td><span *ngIf="!editable">{{item.chargeDescription}}</span><input *ngIf="editable" class="form-control" name="chargeValue-{{i}}" [(ngModel)]="item.chargeDescription" /></td>
      <td>
        <div class="armx-btn-group" *ngIf="isLastIndex(i) && editable">
          <div class="col-sm-6">
            <button class="btn btn-default" (click)="addAddtionalCharge(item)">{{ 'common.add' | translate }}</button>
          </div>
          <div class="col-sm-6">
            <button class="btn btn-primary" (click)="getAddtionalCharges(item)">{{ 'common.done' | translate }}</button>
          </div>
        </div>
      </td>
      <td><div class="col-sm-12">{{item.chargeValue}}</div> </td>
    </tr>
  </tbody>
</table>



